import React from 'react'
import TextReader from '../../components/TextReader'

export default function Show({ text, previous_score, completion_count, user_locale }) {
  return (
    <TextReader
      text={text}
      previous_score={previous_score}
      completion_count={completion_count}
      user_locale={user_locale}
    />
  )
}

